import { createContext, useContext } from 'react';

import type { ApiEmbedSearchWidget } from 'modules/embedSearchWidget/api/types/ApiEmbedSearchWidget';

export const EmbedSearchWidgetContext =
  createContext<ApiEmbedSearchWidget | null>(null);

export function useEmbedSearchWidget(): {
  embedSearchWidget: ApiEmbedSearchWidget | null;
} {
  const embedSearchWidget = useContext(EmbedSearchWidgetContext);
  return { embedSearchWidget };
}
